import { render, staticRenderFns } from "./UserUsageCourseTable.vue?vue&type=template&id=74e2ce10&"
import script from "./UserUsageCourseTable.vue?vue&type=script&lang=ts&"
export * from "./UserUsageCourseTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports